let alert;
let language = localStorage.getItem("languageId");
if (language == 1) {
  // Persian (فارسی)
  alert = {
    success: {
      save: "با موفقیت ذخیره شد",
      send: "اطلاعات شما با موفقیت ارسال شد",
      submit: "با موفقیت ثبت شد",
      done: "عملیات با موفقیت انجام شد",
      edit: "اطلاعات با موفقیت ویرایش شد",
      delete: "با موفقیت حذف شد",
      commentSent: "نظر شما ارسال شد و پس از تأیید نمایش داده خواهد شد",
    },
    error: {
      access: "شما به این بخش دسترسی ندارید",
      notFound: "اطلاعات موردنظر یافت نشد",
      pageNotFound: "داده‌ای برای نمایش وجود ندارد",
      server: "خطا در ارتباط با سرور",
      post: "خطا در انجام عملیات، لطفاً دوباره تلاش کنید",
      upload: "حجم یا فرمت فایل مجاز نیست",
      empty: "لطفاً فیلدهای الزامی را پر کنید",
      emptyTitle: "لطفاً عنوان را وارد کنید",
      emptyComment: "لطفاً نظر خود را بنویسید",
      captcha: "کد کپچا نامعتبر است",
      emptyFields: "لطفاً اطلاعات الزامی را وارد کنید",
    },
  };
} else if (language == 2) {
  // Arabic (العربية)
  alert = {
    success: {
      save: "تم الحفظ بنجاح",
      send: "تم إرسال المعلومات بنجاح",
      submit: "تم التسجيل بنجاح",
      done: "تمت العملية بنجاح",
      edit: "تم تعديل المعلومات بنجاح",
      delete: "تم الحذف بنجاح",
      commentSent: "تم إرسال تعليقك وسيتم نشره بعد المراجعة",
    },
    error: {
      access: "ليس لديك صلاحية الوصول إلى هذا القسم",
      notFound: "المعلومات المطلوبة غير موجودة",
      pageNotFound: "لا توجد بيانات للعرض",
      server: "حدث خطأ في الاتصال بالخادم",
      post: "حدث خطأ أثناء تنفيذ العملية، حاول مرة أخرى",
      upload: "حجم الملف أو نوعه غير مسموح",
      empty: "يرجى ملء الحقول المطلوبة",
      emptyTitle: "يرجى إدخال العنوان",
      emptyComment: "يرجى كتابة تعليقك",
      captcha: "رمز التحقق غير صالح",
      emptyFields: "يرجى إدخال المعلومات المطلوبة",
    },
  };
} else if (language == 3) {
  // English
  alert = {
    success: {
      save: "Saved successfully",
      send: "Your information has been sent successfully",
      submit: "Submitted successfully",
      done: "Operation completed successfully",
      edit: "Information updated successfully",
      delete: "Deleted successfully",
      commentSent: "Your comment has been sent and will be published after approval",
    },
    error: {
      access: "You do not have access to this section",
      notFound: "Requested information not found",
      pageNotFound: "No data available",
      server: "Server connection error",
      post: "An error occurred. Please try again",
      upload: "Invalid file size or format",
      empty: "Please fill in the required fields",
      emptyTitle: "Please enter a title",
      emptyComment: "Please write your comment",
      captcha: "Invalid captcha code",
      emptyFields: "Please complete the required fields",
    },
  };
} else if (language == 4) {
  // Bangla (বাংলা)
  alert = {
    success: {
      save: "সফলভাবে সংরক্ষণ করা হয়েছে",
      send: "আপনার তথ্য সফলভাবে পাঠানো হয়েছে",
      submit: "সফলভাবে জমা দেওয়া হয়েছে",
      done: "কাজটি সফলভাবে সম্পন্ন হয়েছে",
      edit: "তথ্য সফলভাবে আপডেট করা হয়েছে",
      delete: "সফলভাবে মুছে ফেলা হয়েছে",
      commentSent: "আপনার মন্তব্য পাঠানো হয়েছে এবং অনুমোদনের পরে প্রকাশ করা হবে",
    },
    error: {
      access: "এই অংশে আপনার প্রবেশাধিকার নেই",
      notFound: "অনুরোধকৃত তথ্য পাওয়া যায়নি",
      pageNotFound: "দেখানোর জন্য কোনো তথ্য নেই",
      server: "সার্ভারের সাথে সংযোগে সমস্যা হয়েছে",
      post: "একটি ত্রুটি ঘটেছে, আবার চেষ্টা করুন",
      upload: "ফাইলের আকার বা ফরম্যাট সঠিক নয়",
      empty: "অনুগ্রহ করে প্রয়োজনীয় ঘরগুলো পূরণ করুন",
      emptyTitle: "অনুগ্রহ করে শিরোনাম লিখুন",
      emptyComment: "অনুগ্রহ করে আপনার মন্তব্য লিখুন",
      captcha: "ক্যাপচা কোড সঠিক নয়",
      emptyFields: "অনুগ্রহ করে প্রয়োজনীয় তথ্য পূরণ করুন",
    },
  };
} else if (language == 5) {
  // Urdu (اردو)
  alert = {
    success: {
      save: "کامیابی سے محفوظ ہو گیا",
      send: "آپ کی معلومات کامیابی سے بھیج دی گئی ہیں",
      submit: "کامیابی سے جمع کر دیا گیا",
      done: "عمل کامیابی سے مکمل ہو گیا",
      edit: "معلومات کامیابی سے اپ ڈیٹ ہو گئیں",
      delete: "کامیابی سے حذف کر دیا گیا",
      commentSent: "آپ کا تبصرہ بھیج دیا گیا ہے اور منظوری کے بعد شائع ہوگا",
    },
    error: {
      access: "آپ کو اس حصے تک رسائی حاصل نہیں ہے",
      notFound: "درخواست کردہ معلومات موجود نہیں",
      pageNotFound: "دکھانے کے لیے کوئی ڈیٹا موجود نہیں",
      server: "سرور سے رابطے میں مسئلہ پیش آیا",
      post: "عمل کے دوران خرابی پیش آئی، دوبارہ کوشش کریں",
      upload: "فائل کا سائز یا فارمیٹ درست نہیں",
      empty: "براہ کرم ضروری خانے پُر کریں",
      emptyTitle: "براہ کرم عنوان درج کریں",
      emptyComment: "براہ کرم اپنا تبصرہ لکھیں",
      captcha: "کیپچا کوڈ غلط ہے",
      emptyFields: "براہ کرم ضروری معلومات درج کریں",
    },
  };
} else {
  alert = {
    // success: {
    //   save: "با موفقیت ذخیره شد",
    //   send: "اطلاعات شما با موفقیت ارسال شد",
    //   submit: "اطلاعات شما با موفقیت ثبت شد",
    //   done: "با موفقیت انجام شد",
    //   edit: "اطلاعات مدنظر با موفقیت ویرایش شد",
    //   delete: "با موفقیت حذف شد",
    //   commentSent: "نظر شما ارسال شد و پس از تایید در سایت درج خواهد شد",
    // },
    // error: {
    //   access: "متاسفانه شما به این قسمت دسترسی ندارید",
    //   notFound: "اطلاعات مدنظر وجود ندارد",
    //   pageNotFound: "هنوز محتوایی وجود ندارد",
    //   server: "مشکلی در برقراری ارتباط با سرور وجود دارد",
    //   post: "مشکلی در انجام عملیات وجود دارد. مجدد تلاش کنید",
    //   upload: "حجم و یا پسوند فایل مدنظر غیرمجاز می‌باشد",
    //   empty: "لطفا فیلدهای الزامی را وارد کنید",
    //   emptyTitle: "لطفا عنوان را وارد کنید",
    //   emptyComment: "لطفا نظر خود را بنویسید",
    //   wrongMobile: "لطفا شماره همراه به صورت صحیح وارد کنید",
    //   mobileNotFound: "شماره همراه وارد شده یافت نشد",
    //   captcha: "کد کپچا معتبر نمی‌باشد",
    //   emptySelect: "هیچ موردی انتخاب نشده است",
    // },
    success: {
      save: "",
      send: "",
      submit: "",
      done: "",
      edit: "",
      delete: "",
      commentSent: "",
    },
    error: {
      access: "",
      notFound: "",
      pageNotFound: "",
      server: "",
      post: "",
      upload: "",
      empty: "",
      emptyTitle: "",
      emptyComment: "",
      wrongMobile: "",
      mobileNotFound: "",
      captcha: "",
      emptySelect: "",
    },
  };
}

export default alert;

// let alert;
// let language = localStorage.getItem("languageId");

// if (language == 1) {
//   // Persian (فارسی)
//   alert = {
//     success: {
//       save: "با موفقیت ذخیره شد",
//       send: "اطلاعات شما با موفقیت ارسال شد",
//       submit: "با موفقیت ثبت شد",
//       done: "عملیات با موفقیت انجام شد",
//       edit: "اطلاعات با موفقیت ویرایش شد",
//       delete: "با موفقیت حذف شد",
//       commentSent: "نظر شما ارسال شد و پس از تأیید نمایش داده خواهد شد",
//     },
//     error: {
//       access: "شما به این بخش دسترسی ندارید",
//       notFound: "اطلاعات موردنظر یافت نشد",
//       pageNotFound: "داده‌ای برای نمایش وجود ندارد",
//       server: "خطا در ارتباط با سرور",
//       post: "خطا در انجام عملیات، لطفاً دوباره تلاش کنید",
//       upload: "حجم یا فرمت فایل مجاز نیست",
//       empty: "لطفاً فیلدهای الزامی را پر کنید",
//       emptyTitle: "لطفاً عنوان را وارد کنید",
//       emptyComment: "لطفاً نظر خود را بنویسید",
//       captcha: "کد کپچا نامعتبر است",
//       emptyFields: "لطفاً اطلاعات الزامی را وارد کنید",
//     },
//   };
// } else if (language == 2) {
//   // Arabic (العربية)
//   alert = {
//     success: {
//       save: "تم الحفظ بنجاح",
//       send: "تم إرسال المعلومات بنجاح",
//       submit: "تم التسجيل بنجاح",
//       done: "تمت العملية بنجاح",
//       edit: "تم تعديل المعلومات بنجاح",
//       delete: "تم الحذف بنجاح",
//       commentSent: "تم إرسال تعليقك وسيتم نشره بعد المراجعة",
//     },
//     error: {
//       access: "ليس لديك صلاحية الوصول إلى هذا القسم",
//       notFound: "المعلومات المطلوبة غير موجودة",
//       pageNotFound: "لا توجد بيانات للعرض",
//       server: "حدث خطأ في الاتصال بالخادم",
//       post: "حدث خطأ أثناء تنفيذ العملية، حاول مرة أخرى",
//       upload: "حجم الملف أو نوعه غير مسموح",
//       empty: "يرجى ملء الحقول المطلوبة",
//       emptyTitle: "يرجى إدخال العنوان",
//       emptyComment: "يرجى كتابة تعليقك",
//       captcha: "رمز التحقق غير صالح",
//       emptyFields: "يرجى إدخال المعلومات المطلوبة",
//     },
//   };
// } else if (language == 3) {
//   // English
//   alert = {
//     success: {
//       save: "Saved successfully",
//       send: "Your information has been sent successfully",
//       submit: "Submitted successfully",
//       done: "Operation completed successfully",
//       edit: "Information updated successfully",
//       delete: "Deleted successfully",
//       commentSent: "Your comment has been sent and will be published after approval",
//     },
//     error: {
//       access: "You do not have access to this section",
//       notFound: "Requested information not found",
//       pageNotFound: "No data available",
//       server: "Server connection error",
//       post: "An error occurred. Please try again",
//       upload: "Invalid file size or format",
//       empty: "Please fill in the required fields",
//       emptyTitle: "Please enter a title",
//       emptyComment: "Please write your comment",
//       captcha: "Invalid captcha code",
//       emptyFields: "Please complete the required fields",
//     },
//   };
// } else if (language == 4) {
//   // Bangla (বাংলা)
//   alert = {
//     success: {
//       save: "সফলভাবে সংরক্ষণ করা হয়েছে",
//       send: "আপনার তথ্য সফলভাবে পাঠানো হয়েছে",
//       submit: "সফলভাবে জমা দেওয়া হয়েছে",
//       done: "কাজটি সফলভাবে সম্পন্ন হয়েছে",
//       edit: "তথ্য সফলভাবে আপডেট করা হয়েছে",
//       delete: "সফলভাবে মুছে ফেলা হয়েছে",
//       commentSent: "আপনার মন্তব্য পাঠানো হয়েছে এবং অনুমোদনের পরে প্রকাশ করা হবে",
//     },
//     error: {
//       access: "এই অংশে আপনার প্রবেশাধিকার নেই",
//       notFound: "অনুরোধকৃত তথ্য পাওয়া যায়নি",
//       pageNotFound: "দেখানোর জন্য কোনো তথ্য নেই",
//       server: "সার্ভারের সাথে সংযোগে সমস্যা হয়েছে",
//       post: "একটি ত্রুটি ঘটেছে, আবার চেষ্টা করুন",
//       upload: "ফাইলের আকার বা ফরম্যাট সঠিক নয়",
//       empty: "অনুগ্রহ করে প্রয়োজনীয় ঘরগুলো পূরণ করুন",
//       emptyTitle: "অনুগ্রহ করে শিরোনাম লিখুন",
//       emptyComment: "অনুগ্রহ করে আপনার মন্তব্য লিখুন",
//       captcha: "ক্যাপচা কোড সঠিক নয়",
//       emptyFields: "অনুগ্রহ করে প্রয়োজনীয় তথ্য পূরণ করুন",
//     },
//   };
// } else if (language == 5) {
//   // Urdu (اردو)
//   alert = {
//     success: {
//       save: "کامیابی سے محفوظ ہو گیا",
//       send: "آپ کی معلومات کامیابی سے بھیج دی گئی ہیں",
//       submit: "کامیابی سے جمع کر دیا گیا",
//       done: "عمل کامیابی سے مکمل ہو گیا",
//       edit: "معلومات کامیابی سے اپ ڈیٹ ہو گئیں",
//       delete: "کامیابی سے حذف کر دیا گیا",
//       commentSent: "آپ کا تبصرہ بھیج دیا گیا ہے اور منظوری کے بعد شائع ہوگا",
//     },
//     error: {
//       access: "آپ کو اس حصے تک رسائی حاصل نہیں ہے",
//       notFound: "درخواست کردہ معلومات موجود نہیں",
//       pageNotFound: "دکھانے کے لیے کوئی ڈیٹا موجود نہیں",
//       server: "سرور سے رابطے میں مسئلہ پیش آیا",
//       post: "عمل کے دوران خرابی پیش آئی، دوبارہ کوشش کریں",
//       upload: "فائل کا سائز یا فارمیٹ درست نہیں",
//       empty: "براہ کرم ضروری خانے پُر کریں",
//       emptyTitle: "براہ کرم عنوان درج کریں",
//       emptyComment: "براہ کرم اپنا تبصرہ لکھیں",
//       captcha: "کیپچا کوڈ غلط ہے",
//       emptyFields: "براہ کرم ضروری معلومات درج کریں",
//     },
//   };
// }

// export default alert;
